import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  UPDATE_USER_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes";

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  };
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const updateUserSuccess = (name, nickname, url_avatar) => {
  const objPayload = { name: name, nickname: nickname, url_avatar: url_avatar };

  let localAuthUser = JSON.parse(localStorage.authUser);
  localAuthUser.user = Object.assign(localAuthUser.user, objPayload);

  localStorage.authUser = JSON.stringify(localAuthUser);
  return {
    type: UPDATE_USER_SUCCESS,
    payload: objPayload,
  };
};

export const logoutUser = (history, isExpired) => {
  return {
    type: LOGOUT_USER,
    payload: { history, isExpired },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
